<template>
    <div class="space-group-row-container" :class="{moveIcon: !hideMove}" :style="styles" @click="$emit('toggleVisibility')">
        <span v-if="!hideToggleIcon" v-bind:class="{ 'is-active': !hide }" style="top: 1.3rem;"
              class="accordion-item-trigger-icon"></span>
        <div v-if="!hideMove" class="move">
            <span @click="$emit('moveUp')" style="font-size: 12px" class="icon icon-sort-up"></span>
            <span @click="$emit('moveDown')" style="font-size: 12px" class="icon icon-sort-down"></span>
        </div>
        <div style="min-width: 12rem;" v-bind:class="{ bold: bold }">
            {{this.text}}
        </div>
        <div v-if="!hideCopy" @click="$emit('onDuplicate')">
            <span data-type="duplicate" class="hover-highlight icon icon-duplicate"></span>
        </div>
        <div v-if="!hideDelete" @click="$emit('onDelete')">
            <span data-type="delete" class="hover-highlight icon icon-delete"></span>
        </div>
    </div>
</template>

<script>

    export default {
        components: {},
        props: {
            hide: {
                required: false,
                default: false
            },
            text: {
                required: true,
                type: String
            },
            hideDelete: {
                required: false,
                default: false
            },
            hideCopy: {
                required: false,
                default: false
            },
            hideMove: {
                required: false,
                default: false
            },
            bold: {
                required: false,
                default: false
            },
            styles: {
                required: false
            },
            hideToggleIcon: {
                required: false,
                default: false
            }
        },
        data: function () {
            return {}
        },
        name: "SpaceGroupRow",
        mounted() {
        },
        methods: {}
    }
</script>


<style lang="scss" scoped>

    .space-group-row-container {
        padding: 0.7rem 1.3rem;
        background-color: white;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        border-top: 1px solid $lightGrey;
        border-bottom: 1px solid $lightGrey;
    }

    .space-group-row-container.moveIcon{
        padding: 0.7rem 25px;
    }

    .bold {
        font-weight: bold;
    }

    .icon {
        font-size: 1.4rem;
        cursor: pointer;
        margin-right: 1.5rem;
    }

    .move {
        position: absolute;
        top: 3px;
        left: 3px;
        display: flex;
        flex-flow: column;
        height: 36px;
        justify-content: space-between;
        font-size: 12px;
        color: $grey;
        padding: 4px 3px 1px 3px;
        margin-top: 2px;
        cursor: pointer;
    }

</style>